/* tslint:disable */

declare var Object: any;
export interface AppVersionInterface {
  "android_v"?: string;
  "ios_v"?: string;
  "force_android_v"?: string;
  "force_ios_v"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class AppVersion implements AppVersionInterface {
  "android_v": string;
  "ios_v": string;
  "force_android_v": string;
  "force_ios_v": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: AppVersionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AppVersion`.
   */
  public static getModelName() {
    return "AppVersion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AppVersion for dynamic purposes.
  **/
  public static factory(data: AppVersionInterface): AppVersion{
    return new AppVersion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AppVersion',
      plural: 'AppVersions',
      path: 'AppVersions',
      idName: 'id',
      properties: {
        "android_v": {
          name: 'android_v',
          type: 'string'
        },
        "ios_v": {
          name: 'ios_v',
          type: 'string'
        },
        "force_android_v": {
          name: 'force_android_v',
          type: 'string'
        },
        "force_ios_v": {
          name: 'force_ios_v',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
